// extracted by css-extract-rspack-plugin
var _1 = "V4SkxbYMeQW5usXI";
export { _1 as "notifications" }
// extracted by css-extract-rspack-plugin
var _1 = "V4SkxbYMeQW5usXI";
export { _1 as "notifications" }
